//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["origin","alignmentVector","rotationVector","rotationObject","clockAngle"],"CreateProxyPortWithRotationByAbsPosition",{R_:{proxyPort:"Routing.ProxyPort"}},5,0],[["origin","alignmentVector"],"CreateProxyPortNoRotationByAbsPosition",{R_:{proxyPort:"Routing.ProxyPort"}},2,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","point"],"CreateProxyPortWithRotationByPoint",{R_:{proxyPort:"Routing.ProxyPort"}},6,0],[["origin","alignmentVector","point"],"CreateProxyPortNoRotationByPoint",{R_:{proxyPort:"Routing.ProxyPort"}},3,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","axis"],"CreateProxyPortWithRotationOnAxis",{R_:{proxyPort:"Routing.ProxyPort"}},6,0],[["origin","alignmentVector","derivationObject"],"CreateProxyPortNoRotationOnAxis",{R_:{proxyPort:"Routing.ProxyPort"}},3,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","allowMultipleConnections"],"CreateProxyPortWithRotationByAbsPosition1",{R_:{proxyPort:"Routing.ProxyPort"}},6,0],[["origin","alignmentVector","allowMultipleConnections"],"CreateProxyPortNoRotationByAbsPosition1",{R_:{proxyPort:"Routing.ProxyPort"}},3,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","point","allowMultipleConnections"],"CreateProxyPortWithRotationByPoint1",{R_:{proxyPort:"Routing.ProxyPort"}},7,0],[["origin","alignmentVector","point","allowMultipleConnections"],"CreateProxyPortNoRotationByPoint1",{R_:{proxyPort:"Routing.ProxyPort"}},4,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","axis","allowMultipleConnections"],"CreateProxyPortWithRotationOnAxis1",{R_:{proxyPort:"Routing.ProxyPort"}},7,0],[["origin","alignmentVector","derivationObject","allowMultipleConnections"],"CreateProxyPortNoRotationOnAxis1",{R_:{proxyPort:"Routing.ProxyPort"}},4,0]],[]];
SPLM.Routing.ProxyPortCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.ProxyPortCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;